import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '../../shared/TextField';
import { color } from '../../../app/theme';
import Button from '../../shared/Button';
import utils from '../../../app/utils';
import { enqueueSnackbar } from '../../../features/notifierSlice';
import { SnackBarType, PlatformType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 44,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      color: color.$3,
      marginBottom: 6,
    },
    subtitle: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      color: color.$13,
      marginBottom: 12,
    },
    input1: {
      width: 318,
    },
    input2: {
      width: 304,
      marginLeft: 8,
    },
    inputDiv: {
      display: 'flex',
    },
    button: {
      marginLeft: 8,
    },
  },
  {
    name: 'MmeUrl',
  },
);

const MmeUrl = ({ customRef, onChange, disabled }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { integration } = useSelector(store => store.organization);

  function handleCopy() {
    if (!integration) {
      dispatch(
        enqueueSnackbar({
          variant: SnackBarType.ERROR,
          message: t(`recurringMessage:copyFail`),
        }),
      );
      return;
    }
    const integrationId = integration?.find(
      item => item.platform.objectId === PlatformType.FACEBOOK,
    )?.objectId;
    utils.copyToClipboard(
      `https://m.me/${integrationId}?ref=${customRef || ''}`,
      () => {
        dispatch(
          enqueueSnackbar({
            variant: SnackBarType.SUCCESS,
            message: t(`recurringMessage:copySuccess`),
          }),
        );
      },
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('recurringMessage:mme')}</div>
      <div className={classes.subtitle}>{t('recurringMessage:mmeDesc')}</div>
      <div className={classes.inputDiv}>
        <TextField
          className={classes.input1}
          type="text"
          isValid
          placeholder={t('recurringMessage:mmeDefaultUrl')}
          disabled="true"
        />
        <TextField
          className={classes.input2}
          type="text"
          isValid
          value={customRef}
          placeholder={t('recurringMessage:mmeCustomerUrlHint')}
          onChange={e => onChange(e.target.value)}
          disabled={disabled}
        />
        <Button
          className={classes.button}
          topic="primaryBlue"
          onClick={handleCopy}
        >
          {t('recurringMessage:mmeCopy')}
        </Button>
      </div>
    </div>
  );
};

export default MmeUrl;
